import React, { ReactNode } from 'react';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: ReactNode;
}

const Modal: React.FC<ModalProps> = ({ isOpen, onClose, title, children }) => {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-75 transition-opacity duration-300 ease-in-out"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-labelledby="modal-title"
    >
      <div
        className="bg-gray-800 rounded-lg shadow-xl w-full max-w-4xl max-h-[90vh] overflow-y-auto p-6 relative transform transition-all duration-300 ease-in-out scale-95 opacity-0 animate-modal-fade-in"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex justify-between items-start mb-4 pb-3 border-b border-gray-700">
          <h2 id="modal-title" className="text-2xl font-bold text-[#59b9c1]">
            {title}
          </h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-white text-3xl leading-none font-semibold focus:outline-none transition-colors duration-200"
            aria-label="Close modal"
          >
            ×
          </button>
        </div>
        <div className="prose prose-invert max-w-none text-gray-300 prose-h2:text-2xl prose-h2:font-bold prose-h2:text-gray-100 prose-h2:mb-4 prose-h2:mt-6 prose-h3:text-xl prose-h3:font-semibold prose-h3:text-gray-100 prose-h3:mb-3 prose-h3:mt-5 prose-p:text-gray-300 prose-strong:text-gray-100 prose-ul:text-gray-300 prose-li:marker:text-[#59b9c1]">
          {children}
        </div>
      </div>
      <style jsx global>{`
        @keyframes modal-fade-in {
          from {
            opacity: 0;
            transform: scale(0.95);
          }
          to {
            opacity: 1;
            transform: scale(1);
          }
        }
        .animate-modal-fade-in {
          animation: modal-fade-in 0.3s ease-out forwards;
        }
      `}</style>
    </div>
  );
};

export default Modal;
